import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('GUIDE');

export const SET_AUTOPLAY = ActionType.simple('SET_AUTOPLAY');
export const SET_HOURS = ActionType.simple('SET_HOURS');
export const CHANNEL_GUIDE_REQUEST = ActionType.simple('CHANNEL_GUIDE_REQUEST');
export const CHANNEL_GUIDE_LOADED = ActionType.simple('CHANNEL_GUIDE_LOADED');
export const CHANGE_SELECTED_INDEX = ActionType.simple('CHANGE_SELECTED_INDEX');
export const CHANGE_SELECTED_CATEGORY = ActionType.simple('CHANGE_SELECTED_CATEGORY');
export const CHANGE_CURRENT_PLAYING = ActionType.simple('CHANGE_CURRENT_PLAYING');
export const CHANGE_CURRENT_PLAYING_FOR_BI = ActionType.simple('CHANGE_CURRENT_PLAYING_FOR_BI');
export const AD_CLICK_CHANNEL_CHANGE_FOR_BI = ActionType.simple('AD_CLICK_CHANNEL_CHANGE_FOR_BI');
export const EXPAND = ActionType.simple('EXPAND');
export const SHRINK = ActionType.simple('SHRINK');
export const SET_LIST = ActionType.simple('SET_LIST');
export const SELECT_UP = ActionType.simple('SELECT_UP');
export const SELECT_DOWN = ActionType.simple('SELECT_DOWN');
export const SET_PREV_CONTENT_KIND = ActionType.simple('SET_PREV_CONTENT_KIND');
export const CHANNEL_ERROR = ActionType.simple('CHANNEL_ERROR');
export const SHOW_EPISODE_INFO_DIALOG = ActionType.simple('SHOW_EPISODE_INFO_DIALOG');
export const HIDE_EPISODE_INFO_DIALOG = ActionType.simple('HIDE_EPISODE_INFO_DIALOG');
